import { ComboboxSeparator } from '@components/ui/combobox';
import type { ResolvedSchemaTree } from '@root/helpers/schema/types';

import { DatapointAccordion } from './DatapointAccordion';
import SelectorHeader from './SelectorHeader';

interface DataPointsSelectorProps {
  datapointTree: ResolvedSchemaTree[];
  datapointSearch: string;
  setDatapointSearch: (search: string) => void;
  value: string;
  handleDatapointSelect: (id: string) => void;
  setSelectedTab: (tab: null) => void;
}

export default function DataPointsSelector({
  datapointTree,
  datapointSearch,
  setDatapointSearch,
  value,
  handleDatapointSelect,
  setSelectedTab,
}: DataPointsSelectorProps) {
  return (
    <div className="flex flex-col">
      <SelectorHeader
        title="Data Points"
        onBack={() => setSelectedTab(null)}
        search={datapointSearch}
        setSearch={setDatapointSearch}
      />

      <ComboboxSeparator />

      <div className="max-h-[calc(var(--available-height)-150px)] flex-1 overflow-y-auto">
        <DatapointAccordion
          tree={datapointTree}
          search={datapointSearch}
          selectedId={value}
          onSelect={handleDatapointSelect}
        />
      </div>
    </div>
  );
}
